import Store from '@/Store';
import { NavigationGuardNext, Route } from 'vue-router';

/**
 * Description of middleware
 *
 * @return void
 */
export function ScrollToTop(to: Route, from: Route, next: NavigationGuardNext): void {
	// Scroll to top
	if (to.path !== from.path) {
		window.scrollTo(0, 0);
	}

	next();
}
